// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-slider-track-container {
  position: relative;
  width: 100%;
  padding-top: 25px;
}

.audio-slider-track {
  width: 100%;
  position: absolute;
  height: 8px;
  top: 10px;
  left: 0;
  border-radius: 4px;
  border: solid 1px #475b70;
  background-color: #f2f5f8;
}

.audio-slider-track-elapsed {
  border: solid 1px #475b70;
  background-color: #475b70;
  height: 8px;
  position: absolute;
  left: 0;
  top: 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.audio-slider-thumb {
  background-color: #1A8082;
  border-radius: 10px;
  border: 2px solid lightgray;
  position: absolute;
  color: transparent;
  top: 4px;
  z-index: 5;
  width: 20px;
  height: 20px;
  border: solid 2px #1a8082;
  background-color: #e9f7f7;
}`, "",{"version":3,"sources":["webpack://./src/Components/AudioSlider/AudioSlider.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":[".audio-slider-track-container {\n  position: relative;\n  width: 100%;\n  padding-top: 25px;\n}\n\n.audio-slider-track {\n  width: 100%;\n  position: absolute;\n  height: 8px;\n  top: 10px;\n  left: 0;\n  border-radius: 4px;\n  border: solid 1px #475b70;\n  background-color: #f2f5f8;\n}\n\n.audio-slider-track-elapsed {\n  border: solid 1px #475b70;\n  background-color: #475b70;\n  height: 8px;\n  position: absolute;\n  left: 0;\n  top: 10px;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n.audio-slider-thumb {\n  background-color: #1A8082;\n  border-radius: 10px;\n  border: 2px solid lightgray;\n  position: absolute;\n  color: transparent;\n  top: 4px;\n  z-index: 5;\n  width: 20px;\n  height: 20px;\n  border: solid 2px #1a8082;\n  background-color: #e9f7f7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
